import { Brands, Markers } from './constants';

const getMarkerIcon = (company, activeMarker, name) => {
  return {
    url: company === Brands.CENTURY_COMMUNITIES
            ? activeMarker && activeMarker.name === name
              ? Markers.PURPLE_PIN_ACTIVE
              : Markers.PURPLE_PIN
            : activeMarker && activeMarker.name === name
            ? Markers.BLUE_PIN_ACTIVE
            : Markers.BLUE_PIN,
    scaledSize: new google.maps.Size(32, 32)
  };
};

const getMarkerIconSolid = (company, activeMarker, name) => {
  return {
    url: company === Brands.CENTURY_COMMUNITIES
            ? activeMarker && activeMarker.name === name
              ? Markers.PURPLE_PIN_SOLID_ACTIVE
              : Markers.PURPLE_PIN_SOLID
            : activeMarker && activeMarker.name === name
            ? Markers.BLUE_PIN_SOLID_ACTIVE
            : Markers.BLUE_PIN_SOLID,
    scaledSize: new google.maps.Size(32, 32),
    labelOrigin: new google.maps.Point(16, 12)
  };
};

const getClusterMarkerIcon = (company) => {
  return {
    url: company === Brands.CENTURY_COMMUNITIES
            ? Markers.PURPLE_CLUSTER
            : Markers.BLUE_CLUSTER,
    scaledSize: new google.maps.Size(32, 32)
  };
};

export { getMarkerIcon, getClusterMarkerIcon, getMarkerIconSolid };